<template>
<div>
<el-container class="data_skc">
	<el-aside class="aside-style" width="200px">
		<common-nav selec="2"></common-nav>
	</el-aside>
	<el-container>
		<el-header class="common_header">
			<common-header></common-header>
		</el-header>
		<el-main>
			<el-row :gutter="20" class="sixso">
				<el-col :span="24">
					<el-card shadow="always">
						<el-row :gutter="20">
							<el-col :span="10">服务账户主体：<strong>中国金融传媒股份有限公司</strong></el-col>
							<el-col :span="8">服务期截止：<strong>2026-07-31</strong></el-col>
						</el-row>
						
					</el-card>
				</el-col>
			</el-row>

			<el-row :gutter="24" class="page_bar">
				<el-col :span="20" class="page_bar_title">子账户管理</el-col>
				<el-col :span="4"><el-button icon="el-icon-user" type="success" size="small" @click="handleAddSysUser">添加账号</el-button></el-col>
				<!-- <el-col :span="6">
					<el-input placeholder="输入标题查找" v-model="searchValue" class="input-with-select" size="small" >
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</el-col> -->
			</el-row>

			<el-table :data="tableData">
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						<label v-if="scope.row.status == 1" style="color:green">启用</label>
						<label v-if="scope.row.status == 0" style="color:red">停用</label>
					</template>
				</el-table-column>
				<el-table-column prop="power" label="权限">
					<template slot-scope="scope">
						<label v-if="scope.row.power == 3">普通用户</label>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="中文名" ></el-table-column>
				<el-table-column prop="account" label="账户名"></el-table-column>
				<!-- <el-table-column prop="date" label="创建日期" ></el-table-column> -->
				<el-table-column label="操作" fixed="right" width="400">
					<template slot-scope="scope">
							<el-button type="success" v-if="scope.row.status == 0" @click="handleOpenAccount(scope.row)" size="mini" plain>开启</el-button>
							<el-button type="warning" v-if="scope.row.status == 1" @click="handleCloseAccount(scope.row)" size="mini" plain>关闭</el-button>
							<el-button type="primary" @click="handleEditAccount(scope.row)" size="mini" plain>修改资料</el-button>
							<el-button type="primary" @click="handleShowAccountLog(scope.row)" size="mini" plain>操作记录</el-button>
							<el-button type="danger" @click="handleDelAccount(scope.row)" size="mini" plain>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-main>
		<el-footer>copyright &copy; subudian.com</el-footer>
	</el-container>
</el-container>

<el-dialog title="新增子账户" :close-on-click-modal="false" width="40%"  :visible.sync="dialogNewSysUserVisible">
	<el-row :gutter="20" class="sixo">
		<el-col :span="14"><span class="red_dot">*</span>中文名：<el-input size="small"  maxlength="35" v-model="input_nickname" placeholder="请输入内容"></el-input></el-col>
	</el-row>
	<el-row :gutter="20" class="sixo">
		<el-col :span="20"><span class="red_dot">*</span>登录账户名：<el-input size="small"  maxlength="25" v-model="input_account" placeholder="请输入内容"></el-input></el-col>
	</el-row>
	<div class="xootips">请使用英文、数字，<strong style="color: red;">保存后不可修改</strong></div>
	<el-row :gutter="20" class="sixo">
		<el-col :span="20"><span class="red_dot">*</span>登录密码：<el-input size="small" maxlength="15" v-model="input_pass" placeholder="请输入内容"></el-input></el-col>
	</el-row>
	<div class="xootips">请使用英文、数字</div>
	<div slot="footer" class="dialog-footer">
		<el-button @click="dialogNewSysUserVisible = false">取 消</el-button>
		<el-button type="primary" @click="handleSaveNewSysUser">确 定</el-button>
	</div>
</el-dialog>


<el-dialog title="修改子账户资料" :close-on-click-modal="false" width="40%"  :visible.sync="dialogEditSysUserVisible">
	<el-row :gutter="20" class="sixo">
		<el-col :span="14"><span class="red_dot">*</span>中文名：<el-input size="small"  maxlength="35" v-model="edit_staff_name" placeholder="请输入内容"></el-input></el-col>
	</el-row>
	<el-row :gutter="20" class="sixo">
		<el-col :span="16">登录密码：<el-input size="small" maxlength="15" v-model="edit_staff_pass" placeholder="请输入内容"></el-input></el-col>
	</el-row>
	<div class="xootips">请使用英文、数字，<strong style="color: red;">留空表示不更改密码</strong></div>
	<div slot="footer" class="dialog-footer">
		<el-button @click="dialogEditSysUserVisible = false">取 消</el-button>
		<el-button type="primary" @click="handleSaveEditSysUser">确 定</el-button>
	</div>
</el-dialog>


<el-dialog :title="stafflog_title" :close-on-click-modal="false" width="80%"  :visible.sync="dialogSysUserLogVisible">
	<el-table
		:data="stafflog_tabledata"
		height="450" 
		border 
		style="width: 100%" size="mini">
		<el-table-column
		prop="staff_nickname"
		label="账户昵称"
		width="180">
		</el-table-column>
		<el-table-column
		prop="body"
		label="操作内容">
		</el-table-column>
		<el-table-column
		prop="add_date"
		label="日期">
		</el-table-column>
	</el-table>
</el-dialog>

</div>
</template>

<script>
import CommonNav from "@/components/Nav.vue";
import CommonHeader from "@/components/Header.vue";
import * as MN from '@/api/common'

export default {
    name: 'sysset',
	props:['selec'],
	data() {
		return {
			stafflog_title:'操作记录',
			stafflog_tabledata:[],
			dialogSysUserLogVisible:false,
			edit_staff_uuid:'',
			edit_staff_name:'',
			edit_staff_pass:'',
			dialogEditSysUserVisible:false,
			input_nickname:'',
			input_account:'',
			input_pass:'',
			dialogNewSysUserVisible:false,
			tableData:[],
			searchValue:'',
			loading:true,
			curTipsID: '', 
		}
	},
	components: {
		CommonNav,
		CommonHeader
	},
	created() {
		this.initData()
	},
	mounted() {

	},
	methods: {
		handleOpenAccount(rowdata) {
			console.log(rowdata.uuid);
			this.$confirm('将此账户重新开启?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					staff_uuid:rowdata.uuid
				}
				MN.setOpenAccount(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});          
			});
		},
		handleCloseAccount(rowdata) {
			console.log(rowdata.uuid);
			this.$confirm('是否关闭此账户?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					staff_uuid:rowdata.uuid
				}
				MN.setCloseAccount(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
		},
		handleSaveEditSysUser(){
			if( !this.edit_staff_name ){
				me.$message({
					message: '中文名不能为空',
					type: 'warning'
				});
				return
			}
			let me = this;
			let post={
				token:sessionStorage.getItem('subudian_token'),
				edit_staff_uuid:me.edit_staff_uuid,
				edit_staff_name:me.edit_staff_name,
				edit_staff_pass:me.edit_staff_pass,
			}
			MN.setEditAccount(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				me.initData();
				me.$message({
					type: 'success',
					message: '操作成功!'
				});
				me.dialogEditSysUserVisible = false;
			})
		},
		handleEditAccount(rowdata) {
			console.log(rowdata)
			this.edit_staff_uuid = rowdata.uuid ;
			this.edit_staff_name = rowdata.nickname ;
			this.edit_staff_pass = "";
			this.dialogEditSysUserVisible = true;
		},
		handleShowAccountLog(rowdata) {
			this.stafflog_title = rowdata.nickname + "操作记录";
			let me = this;
			let post={
				token:sessionStorage.getItem('subudian_token'),
				staff_uuid:rowdata.uuid
			}
			MN.getStaffLogData(post).then(res => {
				if ( res.list.length > 0 ){
					me.stafflog_tabledata = res.list
				}
			})
			this.dialogSysUserLogVisible = true;
		},
		handleChangeAccountPass(rowdata) {

		},
		handleDelAccount(rowdata) {
			this.$confirm('确定删除此账户吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let me = this;
				let post={
					token:sessionStorage.getItem('subudian_token'),
					staff_uuid:rowdata.uuid
				}
				MN.setDeleteAccount(post).then(res => {
					if( res.status == 'token_out' ){
						me.$message({
							message: '请重新登录系统',
							type: 'warning'
						});
						location.href="https://www.subudian.com";
						return
					}
					me.initData();
					me.$message({
						type: 'success',
						message: '操作成功!'
					});
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			});
		},
		handleSaveNewSysUser(){
			this.loading = true
			if ( !this.input_nickname || !this.input_account || !this.input_pass ){
				this.$message({
				message: '请填写完整',
				type: 'warning'
				});
				return
			}
			let post={
				token:sessionStorage.getItem('subudian_token'),
				nickname:this.input_nickname,
				account:this.input_account,
				pass:this.input_pass,
			}
			let me = this;
			MN.setSaveNewSysUser(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				if( res == 'has_account' ){
					me.$message({
					message: '已有此账户，请更换账户名',
					type: 'warning'
					});
					return
				}
				me.$message({
					message: '创建成功',
					type: 'success'
				});
				me.dialogNewSysUserVisible = false;
				me.initData();
			})
		},
		handleAddSysUser(){
			this.dialogNewSysUserVisible = true;
		},
		initData(){
			let me = this;
			this.loading = true
			let post={
				token:sessionStorage.getItem('subudian_token')
      		}
			MN.getSysUserList(post).then(res => {
				if( res.status == 'token_out' ){
					me.$message({
						message: '请重新登录系统',
						type: 'warning'
					});
					location.href="https://www.subudian.com";
					return
				}
				this.tableData=res.data;
				this.loading=false;
			})
		},
	}
}
</script>

<style scoped>
.sixso{ margin-bottom: 20px; font-size: 14px; color: #d0d0d0; }
.sixso strong{ color: #6991c2; }
.sixo{ margin-top:15px; }
.red_dot{ color: #ff693f; }
.xootips{ color: #a9a9a9; margin-top: 4px; }
</style>
